/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-11-05.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-11-05.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-11-05.mdx';

const metadata = {
  slug: "2019-11-05",
  title: "Kindle Highlights and Node.js Streams",
  author: "Christian Battaglia",
  description: "Minimizing apologies, parsing Kindle highlights with Node.js streams, and the philosophy of a Tuesday hot take as I approach my late 20s.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-11-05T00:00:00.000Z",
  
  readTime: "8 min read",
  tags: ["Node.js","streams","Kindle","apologies","mindfulness","Equinox","personal growth","NYC"],
};

export const Route = createFileRoute('/blog/posts/2019-11-05')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-11-05',
    image: '/og/blog/2019-11-05.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
